var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproved({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    fill: "#16C79A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C3.58163265,0 0,3.58163265 0,8 C0,12.4183673 3.58223289,16 8,16 C12.4183673,16 16,12.4183673 16,8 C16,3.58163265 12.4183673,0 8,0 L8,0 Z M8,15.3601441 C3.94177671,15.3601441 0.639855942,12.0582233 0.639855942,8 C0.639855942,3.94177671 3.94117647,0.639855942 8,0.639855942 C12.0582233,0.639855942 15.3601441,3.94177671 15.3601441,8 C15.3601441,12.0582233 12.0588235,15.3601441 8,15.3601441 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0018007,5.14345738 L6.86434574,10.1248499 L5.06482593,8.32533013 C4.87755102,8.13805522 4.57382953,8.13805522 4.38595438,8.32533013 C4.19807923,8.51260504 4.19867947,8.81632653 4.38595438,9.00420168 L6.51980792,11.1380552 C6.61344538,11.2316927 6.7364946,11.2785114 6.85894358,11.2785114 C6.9789916,11.2785114 7.09963986,11.2334934 7.19267707,11.1434574 L12.6692677,5.83253301 C12.8595438,5.64765906 12.8643457,5.34393758 12.680072,5.15366146 C12.4945978,4.96278511 12.1914766,4.95858343 12.0012005,5.14285714 L12.0018007,5.14345738 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/Approved.939f33dbb24793f4e6252a33edcd67f3.svg";
export { ForwardRef as ReactComponent };